import script from "./EditWindow.vue?vue&type=script&setup=true&lang=js"
export * from "./EditWindow.vue?vue&type=script&setup=true&lang=js"

import "./EditWindow.vue?vue&type=style&index=0&id=3839f598&lang=css"
import "./EditWindow.vue?vue&type=style&index=1&id=3839f598&scoped=true&lang=css"

import exportComponent from "/home/interact/webapp/4.frontend/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-3839f598"]])

export default __exports__